import { absoluteUrl } from '../../utils/seo'

export const guidePath = slug => `/guides/${slug}`
export const guideUrl = slug => absoluteUrl(guidePath(slug))
export const categoryPath = slug => (slug ? `/guides/category/${slug}` : '/guides')
export const tagPath = tag => `/guides/tag/${encodeURIComponent(tag)}`

export const formatGuideDate = timestamp => (timestamp
  ? new Date(timestamp).toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' })
  : '')
